import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SortDirectionFinancing } from '@lsq-frontend/angular-shared/api-service';
import { SupplierDto } from '@lsq-frontend/remote-services/all-java/financing-mk2-services/model/supplier-dto';
import {
    ListSuppliersRequest,
    ListSuppliersService
} from '@lsq-frontend/remote-services/all-java/financing-mk2-services/operations/admin-suppliers-list/list-suppliers';
import { ModalService } from '@lsq-frontend/common-ui';
import { TAKE_ALL } from '../../../supply-chain/constants';

@Component({
    selector: 'toggle-supplier-activation-modal',
    styleUrls: ['./toggle-supplier-activation-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    template: `
        <div class="modal-body toggle-supplier-activation-modal">
            <p class="bottom-margin">{{ !active ? ACTIVE_BODY : INACTIVE_BODY }}</p>
            <data-card class="bottom-margin">
                <div class="data-header">Supplier Name</div>
                <div class="data-value">{{ supplierPreferredName }}</div>
            </data-card>

            <p *ngIf="active" class="bottom-margin">
                <strong>Note:</strong> The following buyers will no longer have visibility to this
                supplier within FastTrack.
            </p>

            <data-card [class.bottom-margin]="!active">
                <div class="data-header">Buyer Relationships</div>
                <lsq-circle-loader *ngIf="!supplierRelationships"></lsq-circle-loader>
                <div *ngIf="supplierRelationships" class="data-wrapper">
                    <div class="data-value" *ngFor="let relationships of supplierRelationships">
                        {{ relationships.buyerPreferredName }}
                    </div>
                </div>
            </data-card>

            <p *ngIf="!active">
                By turning this on, you acknowledge that all of the provided information for the
                supplier has been reviewed and verified.
            </p>
        </div>
    `
})
export class ToggleSupplierActivationModalComponent implements OnInit {
    public ACTIVE_BODY =
        'This allows the supplier listed below to be active and fully visible within FastTrack, including all of their respective buyers.';
    public INACTIVE_BODY =
        'Turning this off will remove supplier visibility in all FastTrack experiences, including their respective buyers. Do not proceed unless you have verified a need for this change for the supplier listed below.';

    public active: boolean;
    public supplierKey: string;
    public supplierPreferredName: string;
    public supplierRelationships: SupplierDto[];

    constructor(
        private _modalService: ModalService,
        private _listSuppliersService: ListSuppliersService
    ) {
        const modalData = this._modalService.modal.data;

        this.supplierKey = modalData.supplierRelationship.supplierKey;
        this.active = modalData.supplierRelationship.active;
        this.supplierPreferredName = modalData.supplierRelationship.supplierPreferredName;
    }

    async ngOnInit() {
        this.supplierRelationships = (
            await this._listSuppliersService.executeOnce(
                new ListSuppliersRequest({
                    pagination: {
                        take: TAKE_ALL,
                        sortColumn: 'buyerPreferredName',
                        sortDirection: SortDirectionFinancing.DESCENDING
                    },
                    filter: {
                        supplierName: this.supplierPreferredName
                    }
                })
            )
        ).rows;
    }
}
